/**
 * @file SerpPreview.tsx
 * @description Превью «как будет в Google» (phase12.0).
 *
 * Симулирует SERP-карточку: URL, заголовок, описание. Цвета приближены к
 * актуальному UI google.ru — помогает редактору видеть итог до публикации.
 */

interface SerpPreviewProps {
  baseUrl: string; // https://chaiberi.ru
  slug: string;
  title: string;
  description: string;
}

export function SerpPreview({ baseUrl, slug, title, description }: SerpPreviewProps) {
  const url = `${baseUrl}/blog/${slug || "article-slug"}`;
  const titleClip = title.length > 60 ? title.slice(0, 60) + "…" : title;
  const descClip = description.length > 160 ? description.slice(0, 160) + "…" : description;

  return (
    <div className="rounded-md border border-on-surface/20 bg-white p-4 font-sans">
      <h3 className="mb-3 text-sm font-semibold text-on-surface">
        Превью результата поиска Google
      </h3>
      <div className="flex flex-col gap-1">
        <div className="text-xs text-[#5f6368]">
          chaiberi.ru › blog › {slug || "article-slug"}
        </div>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[20px] leading-tight text-[#1a0dab] hover:underline"
        >
          {titleClip || "Заголовок статьи"}
        </a>
        <p className="text-sm text-[#4d5156]">
          {descClip || "Описание появится здесь — заполните meta description."}
        </p>
      </div>
    </div>
  );
}
